jQuery(document).ready(function ($) {
  "use strict";

  $(".js-navbar").each(function () {
    let self = {
      class: "js-navbar",
      navbarEl: $(this),
      isStuckMobile: null,
      resizeTimer: {
        global: null,
        subContainerHeights: null,
      },
      subScrollbarClass: "overflow-y-auto overflow-x-hidden",
    };

    self.menuBaseEl = self.navbarEl.find(`.${self.class}__menu-base`);
    self.togglerEl = self.navbarEl.find(`.${self.class}__toggler`);
    self.closeEl = self.navbarEl.find(`.${self.class}__close`);
    self.menuContainerEl = self.navbarEl.find(`.${self.class}__menu-container`);
    self.menuEl = self.navbarEl.find(`.${self.class}__menu`);
    self.buttonEl = self.navbarEl.find(`.${self.class}__button`);
    self.menuIconEls = self.navbarEl.find(`.${self.class}__menu-icon`);
    self.headerBarContentEl = self.navbarEl.find(
      `.${self.class}__header-bar-content`
    );
    self.headerContentEl = self.navbarEl.find(`.${self.class}__header-content`);
    self.subShadowEls = self.navbarEl.find(`.${self.class}__sub-shadow`);
    self.menuSubHeightEls = self.navbarEl.find(
      `.${self.class}__menu-sub-height`
    );
    self.menuSubColumnElSet = [];
    self.headerContainerEl = self.navbarEl.find(
      `.${self.class}__header-container`
    );
    self.menuSubTriggerEls = self.navbarEl.find(
      `.${self.class}__menu-sub-trigger`
    );
    self.menuSubContentEls = self.navbarEl.find(
      `.${self.class}__menu-sub-content`
    );
    self.menuSubScrollbarEls = self.navbarEl.find(
      `.${self.class}__menu-sub-scrollbar`
    );
    self.menuSubContentRootEls = self.menuSubContentEls.filter(
      `.${self.class}__menu-sub-content--root`
    );
    self.hasMenuItemEls = self.navbarEl.find(
      `.${self.class}__menu-item.menu-item-has-children`
    );
    self.hasMenuToggleIconEls = self.navbarEl.find(
      `.${self.class}__menu-item.menu-item-has-children > span > .${self.class}__menu-toggle-icon`
    );
    self.hasSubMenuEls = self.navbarEl.find(
      `.${self.class}__menu-item.menu-item-has-children > .${self.class}__sub-menu`
    );
    self.searchEl = self.navbarEl.find(`.${self.class}__search`);
    self.contactstickEl = self.navbarEl.find(`.${self.class}__contact-stick`);
    self.contactfixedEl = self.navbarEl.find(`.${self.class}__contact-fixed`);

    self.observerDesktop = new IntersectionObserver(
      ([e]) => {
        if (window.matchMedia("(min-width: 1024px)").matches) {
          self.toggleStuckStylesDesktop(e.intersectionRatio < 1);
        }
      },
      { threshold: [1] }
    );

    self.checkStickinessMobile = () => {
      let isStuck = $(window).scrollTop() > 52;

      if (isStuck === self.isStuckMobile) {
        return;
      }

      self.isStuckMobile = isStuck;
      self.toggleStuckStylesMobile();
    };

    self.toggleStuckStylesMobile = () => {
      self.headerBarContentEl.toggleClass("h-7", self.isStuckMobile);
      self.headerBarContentEl.toggleClass("h-12", !self.isStuckMobile);
      self.headerContentEl.toggleClass("h-22", self.isStuckMobile);
      self.headerContentEl.toggleClass("h-30", !self.isStuckMobile);
      self.headerContainerEl.toggleClass("bg-white", self.isStuckMobile);
      self.menuSubContentRootEls.toggleClass("mt-29", self.isStuckMobile);
      self.menuSubContentRootEls.toggleClass("mt-42", !self.isStuckMobile);
      self.searchEl.addClass("js-navbar__search--mobile", !self.isStuckMobile);
    };

    self.toggleStuckStylesDesktop = (isStuck) => {
      self.menuBaseEl.toggleClass(
        "lg:bg-white lg:shadow-lg lg:border-opacity-100 js-navbar__menu-base--sticky",
        isStuck
      );
      self.subShadowEls.toggleClass("shadow-inner", isStuck);
      self.menuEl.toggleClass("border-opacity-0", isStuck);
      self.buttonEl.toggleClass("hidden", !isStuck);
      self.menuIconEls.toggleClass("lg:hidden xl:block", isStuck);
      self.searchEl.toggleClass("js-navbar__search--scroll", isStuck);
      self.contactstickEl.toggleClass("hidden", isStuck);
      self.contactfixedEl.toggleClass("hidden", !isStuck);
      self.headerContainerEl.toggleClass("bg-white", !self.isStuckMobile);
    };

    self.openSearch = function ($trigger) {
      $trigger.parent().addClass("js-navbar__search--opened");
      $trigger.attr("aria-expanded", "true");
      $("body").addClass("with-search-opened");
      // Move focus to the field so keyboard users land on the now-visible
      // input. Use the native focus() (jQuery .trigger('focus') only fires the
      // event, it does not move the actual focus).
      var searchField = $trigger.parent().find(".search-field").get(0);
      if (searchField) {
        searchField.focus();
      }
      $(document).on("click", function (event) {
        if (!$(event.target).closest(self.searchEl).length) {
          self.searchEl.removeClass("js-navbar__search--opened");
          self.searchEl.find(".search-form__trigger").attr("aria-expanded", "false");
          $("body").removeClass("with-search-opened");
        }
      });
    };

    self.searchEl.find(".search-form__trigger").on("click", function () {
      self.openSearch($(this));
    });

    // WCAG 2.1.1: the trigger is a role="button" div, so activate it with
    // Enter/Space the way a native button would.
    self.searchEl.find(".search-form__trigger").on("keydown", function (e) {
      if (e.key === "Enter" || e.key === " " || e.key === "Spacebar") {
        e.preventDefault();
        self.openSearch($(this));
      }
    });

    self.checkMobile = () => {
      let isMobile = !window.matchMedia("(min-width: 1024px)").matches;

      if (isMobile === self.isMobile) {
        return;
      }

      self.isMobile = isMobile;
      self.onChangeDevice();
    };

    self.toggleHeaderContainer = (state) => {
      self.headerContainerEl.toggleClass("z-40 left-0", !state);
      self.headerContainerEl.toggleClass(
        "z-50 left-full -translate-x-full",
        state
      );
    };

    // WCAG 2.4.3: keep elements that are visually hidden by an off-screen
    // transform out of the keyboard tab order. On mobile the whole menu lives
    // off-canvas until the hamburger is opened, and submenu panels are slid in
    // from the right (translate-x-full) — both stay `visible` so without this
    // they remain focusable while closed. `inert` removes them entirely. On
    // desktop the panels are hidden with `visibility:hidden` (CSS), which
    // already removes them from the tab order, so inert must be cleared there.
    self.syncInert = () => {
      if (!self.isMobile) {
        self.menuBaseEl.removeAttr("inert");
        self.menuSubContentEls.removeAttr("inert");
        return;
      }

      // The slide-in menu is considered open once it has `translate-y-full`.
      const menuOpen = self.menuBaseEl.hasClass("translate-y-full");
      self.menuBaseEl.attr("inert", menuOpen ? null : "");

      self.menuSubContentEls.each(function () {
        const el = $(this);
        el.attr("inert", el.hasClass("translate-x-full") ? "" : null);
      });
    };

    self.setSubContainerHeights = () => {
      self.menuSubHeightEls.each(function (index) {
        let menuSubHeightEl = $(this);
        let heights = [];

        menuSubHeightEl.css("height", "");
        heights.push(menuSubHeightEl.height());

        self.menuSubColumnElSet[index].each(function (index) {
          heights.push($(this).height());
        });

        menuSubHeightEl.height(Math.max.apply(Math, heights));
      });
    };

    self.onChangeDevice = () => {
      self.menuBaseEl.removeClass("translate-y-full");

      if (self.isMobile) {
        self.observerDesktop.unobserve(self.menuBaseEl.get(0));
        self.menuBaseEl.removeClass("lg:transition-bg-border-shadow");
        self.toggleStuckStylesDesktop(false);
        setTimeout(() => {
          self.headerBarContentEl.addClass("transition-height");
          self.headerContentEl.addClass("transition-height");
        }, 100);
        $(document).on("scroll.navbar", self.checkStickinessMobile);
        self.checkStickinessMobile();
        self.togglerEl.on("click.navbar", (event) => {
          event.preventDefault();

          if (!self.menuBaseEl.hasClass("translate-y-full")) {
            bodyScrollLock.disableBodyScroll(self.menuContainerEl.get(0), {
              reserveScrollBarGap: false,
            });
            self.menuBaseEl.addClass("translate-y-full");
            self.togglerEl.attr("aria-expanded", "true");
          } else {
            self.headerContainerEl.removeClass("-translate-x-full");
            self.menuSubContentEls.addClass("translate-x-full");
            self.menuContainerEl.addClass("overflow-y-auto");
          }

          self.syncInert();
        });
        self.closeEl.on("click.navbar", (event) => {
          event.preventDefault();
          bodyScrollLock.clearAllBodyScrollLocks();
          self.menuBaseEl.removeClass("translate-y-full");
          self.togglerEl.attr("aria-expanded", "false");
          self.toggleHeaderContainer(false);
          self.syncInert();
        });
        $(window).off("resize.navbarsubcont");
        clearTimeout(self.resizeTimer.subContainerHeights);
        self.menuSubHeightEls.css("height", "");
        self.menuSubTriggerEls.each(function (index) {
          let menuNavTriggerEl = $(this);
          let menuNavContentEl = menuNavTriggerEl.next(
            `.${self.class}__menu-sub-content`
          );
          let menuNavScrollbarEl = menuNavContentEl.children(
            `.${self.class}__menu-sub-scrollbar`
          );
          let menuNavBackEl = menuNavContentEl.children(
            `.${self.class}__menu-sub-back`
          );
          let menuNavScrollbarParentEl = menuNavTriggerEl
            .closest(`.${self.class}__menu-sub-content`)
            .children(`.${self.class}__menu-sub-scrollbar`);

          menuNavTriggerEl.on("click.navbar", (event) => {
            if (
              !menuNavTriggerEl.hasClass(
                "js-navbar__menu-sub-trigger--submenu-disabled"
              )
            ) {
              event.preventDefault();
              self.toggleHeaderContainer(true);
              menuNavContentEl.removeClass("translate-x-full");
              self.menuContainerEl.removeClass("overflow-y-auto");
              self.menuSubScrollbarEls.removeClass(self.subScrollbarClass);
              menuNavScrollbarEl.addClass(self.subScrollbarClass);
              self.syncInert();
            }
          });

          menuNavBackEl.on("click.navbar", (event) => {
            event.preventDefault();

            menuNavContentEl.addClass("translate-x-full");
            menuNavScrollbarEl.removeClass(self.subScrollbarClass);
            menuNavScrollbarParentEl.addClass(self.subScrollbarClass);
            self.syncInert();
          });
        });
        self.hasMenuItemEls.each(function (index) {
          $(this).on("click.navbar", (event) => {
            if (0 === $(event.target).closest("a").length) {
              event.preventDefault();

              $(self.hasMenuToggleIconEls.get(index)).toggleClass("rotate-180");

              $(self.hasSubMenuEls.get(index)).slideToggle(300, function () {
                $(this).css("display", "").toggleClass("hidden");
              });
            }
          });
        });
        self.syncInert();
      } else {
        self.menuSubTriggerEls.off("click.navbar");
        self.menuSubContentEls.addClass("translate-x-full");
        self.menuSubScrollbarEls.removeClass(self.subScrollbarClass);
        self.toggleHeaderContainer(false);
        self.observerDesktop.observe(self.menuBaseEl.get(0));
        self.headerBarContentEl.removeClass("transition-height");
        self.headerContentEl.removeClass("transition-height");
        $(document).off("scroll.navbar");
        self.togglerEl.off("click.navbar");
        self.closeEl.off("click.navbar");
        self.togglerEl.attr("aria-expanded", "false");
        bodyScrollLock.clearAllBodyScrollLocks();
        setTimeout(() => {
          self.menuBaseEl.addClass("lg:transition-bg-border-shadow");
        }, 100);
        $(window).on("resize.navbarsubcont", () => {
          clearTimeout(self.resizeTimer.subContainerHeights);
          self.resizeTimer.subContainerHeights = setTimeout(() => {
            self.setSubContainerHeights();
          }, 100);
        });
        self.setSubContainerHeights();
        self.hasMenuItemEls.off("click.navbar");
        self.syncInert();
      }
    };

    $(window).on("resize", () => {
      clearTimeout(self.resizeTimer.global);
      self.resizeTimer.global = setTimeout(() => {
        self.checkMobile();
      }, 100);
    });

    self.menuSubHeightEls.each(function (index) {
      self.menuSubColumnElSet[index] = $(this).find(
        `.${self.class}__menu-sub-column`
      );
    });

    // WCAG 4.1.2: expose the open/closed state of each top-level dropdown via
    // aria-expanded on its trigger. On desktop the panel is revealed by the CSS
    // :focus-within variant, so mirror that here when focus enters/leaves the
    // parent <li>. The trigger is either a direct <a> child (the ACF megamenu)
    // or wrapped in the has_before <span> (standard submenus).
    self.topTriggerEl = (li) => {
      let trigger = li.children("a").first();
      if (!trigger.length) trigger = li.children("span").children("a").first();
      return trigger;
    };
    self.menuEl
      .children(".js-navbar__menu-item.parent")
      .filter(function () {
        return (
          $(this).children(
            ".js-navbar__sub-menu, .js-navbar__menu-sub-content--root"
          ).length > 0
        );
      })
      .each(function () {
        const li = $(this);
        const trigger = self.topTriggerEl(li);
        if (!trigger.length) return;
        trigger.attr("aria-haspopup", "true");
        trigger.attr("aria-expanded", "false");
        li.on("focusin.navbar-a11y", function () {
          if (self.isMobile || li.hasClass("is-force-closed")) return;
          trigger.attr("aria-expanded", "true");
        });
        li.on("focusout.navbar-a11y", function () {
          setTimeout(() => {
            if (!li.get(0).contains(document.activeElement)) {
              trigger.attr("aria-expanded", "false");
            }
          }, 0);
        });
      });

    // WCAG 2.1.1 + 1.4.13: Escape closes an open megamenu submenu and restores
    // focus to its trigger. Bound once (delegated) so the same handler covers
    // both breakpoints. On desktop the submenu is revealed by CSS :focus-within
    // so we add `.is-force-closed` to the parent <li> to override the variant
    // until focus leaves the parent. On mobile we re-use the existing back
    // button click handler.
    self.menuBaseEl.on("keydown.navbar-a11y", function (event) {
      if (event.key !== "Escape" && event.keyCode !== 27) return;
      const active = document.activeElement;
      if (!active || active === document.body) return;

      // Mobile: a submenu content slide is open (does not have translate-x-full).
      const openMobileContent = self.menuSubContentEls
        .not(".translate-x-full")
        .filter((_, el) => $(el).has(active).length > 0)
        .not(`.${self.class}__menu-sub-content--root`)
        .first();
      if (openMobileContent.length) {
        event.preventDefault();
        const backBtn = openMobileContent.children(
          `.${self.class}__menu-sub-back`
        );
        const trigger = openMobileContent.prev(".js-navbar__menu-sub-trigger");
        backBtn.trigger("click.navbar");
        if (trigger.length) {
          trigger.trigger("focus");
        }
        return;
      }

      // Desktop: close ONE level at a time (WAI-ARIA menu behaviour). Walk up
      // from the focused element to the nearest `.parent` that (a) is not
      // already force-closed and (b) actually owns an open submenu panel. Close
      // that panel and return focus to its own trigger, leaving any outer
      // levels open. Pressing Escape again then closes the next level up, and
      // so on until the whole megamenu is closed and focus is on the top-level
      // trigger.
      const root = self.menuBaseEl.get(0);
      let owner = null;
      for (let node = active; node && node !== root; node = node.parentElement) {
        const $node = $(node);
        if (
          $node.hasClass("parent") &&
          !$node.hasClass("is-force-closed") &&
          $node.children(
            ".js-navbar__sub-menu, .js-navbar__menu-sub-content"
          ).length > 0
        ) {
          owner = $node;
          break;
        }
      }
      if (!owner) return;
      const trigger = self.topTriggerEl(owner);
      if (!trigger.length) return;
      event.preventDefault();
      owner.addClass("is-force-closed");
      if (trigger.is("[aria-expanded]")) {
        trigger.attr("aria-expanded", "false");
      }
      trigger.trigger("focus");
    });

    // When focus actually leaves a force-closed parent (at any nesting level),
    // reset the flag so the submenu can open again the next time focus enters.
    self.menuBaseEl.on(
      "focusout.navbar-a11y",
      ".parent.is-force-closed",
      function () {
        const parentEl = $(this);
        setTimeout(() => {
          if (!parentEl.get(0).contains(document.activeElement)) {
            parentEl.removeClass("is-force-closed");
          }
        }, 0);
      }
    );

    self.checkMobile();
  });

  // Hide search after scroll
  $(document).on("scroll", function () {
    $(".js-navbar__search--opened").removeClass("js-navbar__search--opened");
    $(".js-navbar__search .search-form__trigger").attr("aria-expanded", "false");
    $(".with-search-opened").removeClass("with-search-opened");
  });

  // Function to show the dropdown
  function showDropdown(dropdown) {
    dropdown
      .removeClass("opacity-0 translate-y-5 -z-10 pointer-events-none") // Remove hidden classes
      .addClass("opacity-100 translate-y-0 z-10 pointer-events-auto") // Add visibility classes
      .removeAttr("inert"); // WCAG 2.4.3: allow tabbing into the open dropdown
    $(".js-tools-trigger").attr("aria-expanded", "true");
  }

  // Function to hide the dropdown
  function hideDropdown(dropdown) {
    dropdown
      .removeClass("opacity-100 translate-y-0 z-10 pointer-events-auto") // Remove visibility classes
      .addClass("opacity-0 translate-y-5 -z-10 pointer-events-none") // Add hidden classes
      .attr("inert", ""); // WCAG 2.4.3: keep the closed dropdown out of the tab order
    $(".js-tools-trigger").attr("aria-expanded", "false");
  }

  // Function to switch the button label to active state
  function setButtonLabelToActive() {
    $(".js-tools-trigger__label--default").addClass("hidden"); // Hide default label on all triggers
    $(".js-tools-trigger__label--active").removeClass("hidden"); // Show active label on all triggers
  }

  // Function to switch the button label to default state
  function setButtonLabelToDefault() {
    $(".js-tools-trigger__label--active").addClass("hidden"); // Hide active label on all triggers
    $(".js-tools-trigger__label--default").removeClass("hidden"); // Show default label on all triggers
  }

  // Add click event handler to open and close the dropdown
  $(".js-tools-trigger").on("click", function (event) {
    event.preventDefault(); // Prevent default behavior of links or buttons
    const dropdown = $(".js-tools-dropdown");

    // Toggle the dropdown visibility
    if (dropdown.hasClass("opacity-100")) {
      hideDropdown(dropdown);
      setButtonLabelToDefault(); // Set label to default when dropdown is hidden
    } else {
      showDropdown(dropdown);
      setButtonLabelToActive(); // Set label to active when dropdown is shown
    }
  });

  // Optionally: hide the dropdown when clicking outside of it
  $(document).on("click", function (event) {
    if (
      !$(event.target).closest(".js-tools-trigger, .js-tools-dropdown").length
    ) {
      hideDropdown($(".js-tools-dropdown"));
      setButtonLabelToDefault(); // Set label to default when clicking outside
    }
  });

  // Hide dropdown when hovering over ".js-navbar__menu-sub-trigger"
  $(".js-navbar__menu-sub-trigger").on("mouseenter", function () {
    hideDropdown($(".js-tools-dropdown"));
    setButtonLabelToDefault(); // Set label to default when hiding dropdown
  });

  // WCAG 2.1.1: Escape closes the tools dropdown and returns focus to its
  // trigger.
  $(document).on("keydown", function (event) {
    if (event.key !== "Escape" && event.keyCode !== 27) return;
    const dropdown = $(".js-tools-dropdown");
    if (!dropdown.hasClass("opacity-100")) return;
    hideDropdown(dropdown);
    setButtonLabelToDefault();
    $(".js-tools-trigger").trigger("focus");
  });

  // Close the tools dropdown once focus leaves both the trigger and the panel,
  // so a keyboard user tabbing past it does not leave it stuck open.
  $(document).on("focusout", function () {
    setTimeout(() => {
      const dropdown = $(".js-tools-dropdown");
      if (!dropdown.hasClass("opacity-100")) return;
      if (
        !$(document.activeElement).closest(".js-tools-trigger, .js-tools-dropdown")
          .length
      ) {
        hideDropdown(dropdown);
        setButtonLabelToDefault();
      }
    }, 0);
  });
});
